const content = {
  tagline: '',
  title: '4423.ch',
  subtitle: 'yon-yon-ni-san',
};

export default content;
